module.exports = __webpack_public_path__ + "img/hiit_splash.b0048400.jpg";